import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const scrollPosition = window.sessionStorage.getItem(this.storageKey)
    if (!scrollPosition) return

    window.sessionStorage.removeItem(this.storageKey)
    requestAnimationFrame(() => window.scrollTo(0, parseInt(scrollPosition, 10)))
  }

  remember() {
    window.sessionStorage.setItem(this.storageKey, String(window.scrollY))
  }

  get storageKey() {
    return `preserve-scroll:${window.location.pathname}`
  }
}
